import axios from 'axios';
import { refreshToken, checkHttpStatus } from '../../common/utils/ApiUtils';
import { NEW_MEMBER, NEW_MEMBER_ADMIN } from './index';

const MEMBER_SERVICE_BASE_URL = window.config.service.memberServiceApiUrl;

refreshToken('member-service-api');

export function addNewMember(params = {}) {
    const url = `${MEMBER_SERVICE_BASE_URL}/member`;
    const response = axios.post(url, {member: params});

    return {
        type: NEW_MEMBER,
        payload: response.then(checkHttpStatus)
    }
}

export function addNewMemberAdmin(params = {}) {
    const url = `${MEMBER_SERVICE_BASE_URL}/memberAdmin`;
    const response = axios.post(url, params);

    return {
        type: NEW_MEMBER_ADMIN,
        payload: response.then(checkHttpStatus)
    }
}
